/*
    表单区分组区域组件
    created by: liyaoh 2019-05-22
*/
import React, { Component } from 'react';
import { DropTarget } from 'react-dnd';
import { connect } from "react-redux";
import { processClass } from '../LeftSideMetaTree/util';

const areaTarget = {
    drop(props, monitor, component) {
        const dragItem = monitor.getItem();
        //从左侧拖拽非元数据
        if (dragItem.type === 'card') {
            props.onDrop(monitor);
        }
    }
};

//DropTarget用于包装接收拖拽元素的组件，使组件能够放置
@DropTarget('area', areaTarget, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
}))
class FormGroupArea extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const {
            group,
            isActive,
            contentVisible,
            renderCard,
            onClick,
            renderHeader,
            emptyText,
            connectDropTarget,
            areaHide
        } = this.props;
        let queryPropertyList = group.queryPropertyList;
        let listWithBlank = [...queryPropertyList, { blank: true, pk_form_property: 'blank', areaid: group.pk_area }];
        let processedCode = processClass(group.code) || 'unknow';
        return !areaHide[group.pk_area] && connectDropTarget(
            <div
                type="ncdiv"
                fieldid={`${group.code}_group`}
                className={`form-area-group ${isActive ? 'active' : ''}  search-area-${String(group.code).replace(/\.|\&|\#/g, '') || 'unknow'} drag-mask-${processedCode}`}
                onClick={onClick}
            >
                {renderHeader}
                <div className="form-area-content" style={{ display: contentVisible ? "block" : "none" }}>
                    {
                        listWithBlank.length > 0 ? listWithBlank.map(renderCard)
                            :
                            <div className="empty-area">
                                <i className="iconfont icon-zhuyi1" />
                                {emptyText}
                            </div>
                    }
                </div>
            </div>
        )
    }
}

export default connect(
    (state) => ({
        areaHide: state.zoneSettingData.areaHide,
    })
)(FormGroupArea);
